import React, { useState, useContext, useEffect, use } from 'react';
import { getHeaderBar, getPaystore } from '../../api/api';

const HeaderBar = (props) => {
    const [paystore, setPaystore] = useState([]);
    const loadPaystore = async () => {
        setPaystore([await getPaystore("GIARRE"), await getPaystore("MASCALI")]);
    };

    const companyID = props.userDetails && props.userDetails.Company ? props.userDetails.Company[0].dataID : null;
    const [headerBar, setHeaderBar] = useState([]);
    const fetchHeaderBar = async () => {
        const response = await getHeaderBar(companyID);
        setHeaderBar(response.data.data.getSettingListing.edges);
    };

    useEffect(() => {
        if (companyID) {
            fetchHeaderBar();
        }
    }, [companyID]);

    useEffect(() => {
        if (headerBar.length > 0) {
            loadPaystore();
        }
    }, [headerBar]);

    return (
        <div className="alert alert-secondary alert-dismissible fade show mb-0 rounded-0" role="alert" style={{ overflow: 'hidden', whiteSpace: 'nowrap' }}
            onMouseEnter={() => { document.querySelector('.alert div').style.animationPlayState = 'paused'; }}
            onMouseLeave={() => { document.querySelector('.alert div').style.animationPlayState = 'running'; }}>
            <div style={{ display: 'inline-block', animation: 'scroll 20s linear infinite', paddingLeft: '100%' }}>
                {headerBar && headerBar.length > 0 ? headerBar.map((item, index) => (
                    item.node.name === "Paystore" ? (
                        <span key={index}>
                            <strong>{item.node.name}: </strong>
                            {paystore && paystore.length > 0 ? paystore.map((ps, psindex) => (
                                <span key={psindex}>➡️{psindex === 0 ? "GIARRE" : "MASCALI"}  <strong>{ps.data.balance.toFixed(2)}€</strong> </span>
                            )) : "Caricamento..."}</span>
                    ) :
                        (<span key={index}>&nbsp;&nbsp;&nbsp;&nbsp; <strong>{item.node.name}: </strong> {item.node.val}</span>)
                )) : ""}
            </div>
            <style>{`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-100%); }
          }
        `}</style>
        </div>
    )
}
export default HeaderBar;